import type { EnvironmentConfig, LogLevel } from "./development";

/**
 * Production environment configuration
 */
export const productionConfig: EnvironmentConfig = {
  // API Configuration
  apiTimeout: 60000,
  enableMockData: false,
  enableDebugMode: false,

  // Logging Configuration
  logLevel: "error" as LogLevel,
  enableConsoleLogging: false,
  enableNetworkLogging: false,

  // Performance Configuration
  enablePerformanceMonitoring: true,
  enableSourceMaps: false,

  // Feature Flags
  features: {
    enableNewUI: true,
    enableExperimentalFeatures: false,
    enableBetaFeatures: false,
  },

  // Development Tools
  enableDevTools: false,
  enableHotReload: false,
  enableErrorBoundary: true,

  // Cache Configuration
  cacheTimeout: 30 * 60 * 1000, // 30 minutes
  enableCaching: true,
};
